import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import useDocumentScrollThrottled from './UseDocumentScrollThrottled';
import GravityForm from "react-gravity-form";

const Header = ({ context }) => {
    
    const ctxGlobal 	= () => context.global;
	const global 		= ctxGlobal();

    const posts = () => context.posts;
    const post = posts()[0];	

	function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
  	
  	function handlePrivacyToggle(evt) {
	  	evt.preventDefault();
	  	context.togglePrivacy();
  	}
  	
  	if (post) {
		  	
		return (
			<>
		    	<header className="c-header">
					<h2 className="c-header__logo" dangerouslySetInnerHTML={ {__html: '<svg viewBox="0 0 252 33"><path d="m14.85 0.04h-14.85v32.16h5.74v-13.58h9.11c5.28 0 10.43-2.41 10.43-9.34 0-6.97-5.19-9.24-10.43-9.24zm-0.78 13.98h-8.33v-9.38h8.33c3.64 0 5.51 1.41 5.51 4.65 0.01 3.64-2.23 4.73-5.51 4.73zm36.21 6.6c0 5.15-3.05 7.74-7.61 7.74-4.6 0-7.7-2.78-7.7-7.74v-20.58h-5.74v20.59c0 7.79 5.28 12.34 13.44 12.34 7.51 0 13.34-3.96 13.34-12.34v-20.59h-5.74v20.58zm37.12 6.52v-4.96c0-3.96-2.14-5.56-5.06-6.15 1.69-0.36 5.15-2.19 5.15-7.56 0-5.56-4.46-8.43-10.79-8.43h-14.3v32.15h5.6v-13.57h9.06c3.1 0 4.69 1.41 4.69 4.55v4.69c-0.13 1.56 0.34 3.11 1.32 4.33h6.19c-1.31-1.34-1.99-3.18-1.86-5.05zm-10.98-13.13h-8.42v-9.38h8.29c3.64 0 5.6 1.64 5.6 4.42 0 2.32-1.28 4.96-5.47 4.96zm140.19 18.18h5.74v-32.15h-5.74v32.15zm9.52-32.15v4.6h10.07v27.56h5.69v-27.56h10.11v-4.6h-25.87zm-24.18 0h-14.85v32.16h5.74v-13.58h9.11c5.28 0 10.43-2.41 10.43-9.34 0-6.97-5.2-9.24-10.43-9.24zm-0.78 13.98h-8.33v-9.38h8.33c3.64 0 5.51 1.41 5.51 4.65 0 3.64-2.23 4.73-5.51 4.73zm-46.41 3.92h16.17v-4.6h-16.17v-8.7h16.8v-4.6h-22.54v32.16h22.91v-4.6h-17.17v-9.66zm-25.78-17.9h-5.74v32.16h21.95v-4.6h-16.21v-27.56zm-20.4 0h-14.85v32.16h5.74v-13.58h9.11c5.28 0 10.43-2.41 10.43-9.34 0-6.97-5.19-9.24-10.43-9.24zm-0.77 13.98h-8.33v-9.38h8.33c3.64 0 5.51 1.41 5.51 4.65 0 3.64-2.23 4.73-5.51 4.73z"/></svg>'}}></h2>
					<a href="#" className="c-header__menu-button" onClick={handleMenuToggle}>Menu</a>
					<a href="#" className="c-header__close-button" onClick={handleMenuToggle}>Close</a>
					{post.reservations_url &&
						<a className="c-header__reservations" href={post.reservations_url} dangerouslySetInnerHTML={{__html:'Reservations<span></span>'}} target="_blank"></a>
					}
				</header>
				<div className="c-menu">
					<ul className="c-menu__list">
						{post.reservations_url &&
							<li className="c-menu__item">
								<a className="c-menu__link" href={post.reservations_url} target="_blank" dangerouslySetInnerHTML={ {__html: 'Reservations'}}></a>
								{post.reservations_desc &&
									<div className="scope-menu-text" dangerouslySetInnerHTML={{__html: post.reservations_desc}}></div>
								}
							</li>
						}
						{post.functions_email && post.functions_email && post.functions_subject &&
							<li className="c-menu__item">
								<a className="c-menu__link" href={'mailto:' + post.functions_email + '?subject=' + post.functions_subject} dangerouslySetInnerHTML={ {__html: 'Functions'}}></a>
								{post.functions_desc &&
									<div className="scope-menu-text" dangerouslySetInnerHTML={{__html: post.functions_desc}}></div>
								}
							</li>
						}
						{post.recruitment_email && post.recruitment_subject &&
							<li className="c-menu__item">
								<a className="c-menu__link" href={'mailto:' + post.recruitment_email + '?subject=' + post.recruitment_subject} dangerouslySetInnerHTML={ {__html: 'Recruitment'}}></a>
							</li>
						}
						{post.enquiries_email && post.enquiries_subject &&
							<li className="c-menu__item">
								<a className="c-menu__link" href={'mailto:' + post.enquiries_email + '?subject=' + post.enquiries_subject} dangerouslySetInnerHTML={ {__html: 'Enquiries'}}></a>
							</li>
						}
						{post.instagram_url &&
							<li className="c-menu__item">
								<a className="c-menu__link" href={post.instagram_url} target="_blank" dangerouslySetInnerHTML={ {__html: 'Instagram'}}></a>
							</li>
						}
					</ul>
					{post.form_id &&
						<div className="c-menu__form">
							<div className="scope-form">
								<GravityForm
									backendUrl={document.location.origin + '/wp-json/purplepit/v1/form'}
									formID={post.form_id}
								/>
							</div>
						</div>
					}
					{post.privacy &&
						<a href="#" className="c-menu__privacy" onClick={handlePrivacyToggle} dangerouslySetInnerHTML={ {__html:'Privacy / disclaimer'}}></a>
					}
				</div>
				{post.privacy &&
					<div className="c-privacy">
						<div className="c-privacy__inner">
							<div className="c-privacy__text scope-text" href={post.instagram_url} dangerouslySetInnerHTML={{__html:post.privacy}}></div>
						</div>
					</div>
				}					
			</>
		)
	} else {
		return null;
	}
		
}
export default WithConsumer(Header);